import { render } from "./PointSelectTreeTest.vue?vue&type=template&id=33824af0"
import script from "./PointSelectTreeTest.vue?vue&type=script&lang=js"
export * from "./PointSelectTreeTest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__